import { type HTMLAttributes, type ReactNode } from 'react';

import { Container } from './styles';

export interface IMainContainerProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export const MainContainer = ({
  children,
  ...props
}: IMainContainerProps): JSX.Element => {
  return (
    <Container {...props} data-cy="main-container">
      {children}
    </Container>
  );
};
